module.exports = __webpack_public_path__ + "media/images/frontend/heros/consumer-663841847c0a2bb6b72434f682badb20.jpg";